// Generated by purs version 0.15.15
import * as Control_Apply from "../Control.Apply/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
var for2 = function (dictApply) {
    var apply = Control_Apply.apply(dictApply);
    var map = Data_Functor.map(dictApply.Functor0());
    return function (x) {
        return function (y) {
            return function (f) {
                return apply(map(f)(x))(y);
            };
        };
    };
};
export {
    for2
};
